import React from "react";
import { useTranslation } from "react-i18next";
import { ApplicationDocumentEntry } from "../../types";

interface Props {
  entries: ApplicationDocumentEntry[];
}

export const DocumentSummary: React.FC<Props> = ({ entries }) => {
  const { t } = useTranslation();
  if (!entries?.length) return null;
  return (
    <p>
      {t("documentSummary.uploaded")} <strong>{entries.length}</strong>
    </p>
  );
};
